import AmexGDAOffersTerms from './AmexGDAOffersTerms';

export default AmexGDAOffersTerms;
